import React from "react";
import Box, { BoxProps } from "@mui/joy/Box";

export default function MainContent({ children, ...rest }: BoxProps) {
  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        px: { xs: 2, sm: 3, md: 6 },
        py: { xs: "calc(var(--Header-height) + 24px)", md: 4 },
        display: "flex",
        flexDirection: "column",
        gap: 3,
        minHeight: "100dvh",
        backgroundColor: "var(--joy-palette-background-level1)",
        marginLeft: { xs: 0, md: "var(--Sidebar-width)" },
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
